<div class="modal-footer user-select-none">
    @if (selectedItemCount !== undefined && !errorText) {
    <div class="modal-footer-info">
        <div class="list-metric-counter">
            <span [ngPlural]="selectedItemCount">
                <ng-template ngPluralCase="=1">1 item selected</ng-template>
                <ng-template ngPluralCase="other">{{ selectedItemCount }} items selected</ng-template>
            </span>
        </div>
    </div>
    }
    @if (deleteButtonText) {
        <div class="modal-footer-info">
            <button class="btn btn-outline btn-danger" (click)="deleteHandler.emit()" [textContent]="deleteButtonText"></button>
        </div>
    }
    @if (checkbox) {
    <div class="modal-footer-info">
        <label class="custom-control custom-checkbox text-default">
            <input class="custom-control-input"
                   type="checkbox"
                   [ngModel]="checkbox.value"
                   [disabled]="!!checkbox.disabled"
                   (ngModelChange)="checkboxHandler.emit($event)">
            <span class="custom-control-indicator"></span>
            <span class="custom-control-description" [textContent]="checkbox.label"></span>
        </label>
    </div>
    }
    <div class="popupFooter">
        @if (errorText) {
        <span class="text-red"
              [textContent]="errorText">
        </span>
        }
        @if (noteText && !errorText) {
        <span class="modal-footer-info"
              [textContent]="noteText">
        </span>
        }
    </div>
    <div class="modal-footer-actions">
        @if (showCancelButton) {
        <div class="btn btn-text"
             [textContent]="cancelButtonText"
             (click)="cancelHandler.emit()">
            Cancel
        </div>
        }
        @if (secondaryButtonText !== undefined) {
        <div tabindex="0"
             class="btn"
             [ngClass]="secondaryButtonClasses"
             ycnDisabled [disabled]="disableSecondary"
             [attr.data-test-id]="modalTestId ? modalTestId + '-secondary-button' : secondaryButtonText"
             [textContent]="secondaryButtonText"
             (click)="secondaryHandler.emit()">
        </div>
        }
        @if (showSubmitButton) {
        <div tabindex="0"
             ycnDisabled [disabled]="disableSubmission"
             class="btn"
             [ngClass]="submitButtonClasses"
             [attr.data-test-id]="modalTestId ? modalTestId + '-submit-button' : submitButtonText"
             (click)="submitHandler.emit()">
            @if (loading) {
            <div class="mr-1">
                <div class="loader-spinner-context loader-xs white"></div>
            </div>
            }
            {{submitButtonText}}
        </div>
        }
    </div>
</div>
